module.exports = __webpack_public_path__ + "wordle.png?145ef064314d6b556d7ff0a1538dbfe9";